// src/components/ui/InputLabel.tsx
import React from "react";
import { InputLabel as MuiInputLabel, InputLabelProps } from "@mui/material";

export const InputLabel: React.FC<InputLabelProps> = (props) => (
  <MuiInputLabel {...props} />
);
